import cx from 'classnames';
import Image from 'next/image';

import {Button, Text} from '#component/base';
import {sprinkles} from '#style/sprinkles';

import {StepProps} from '../../Register.types';

import * as css from './StepIntro.css';

export const StepIntro = ({onNext, data, className}: StepProps) => (
  <div className={cx(className, css.intro)}>
    <div className={css.text}>
      <Text variant="heading2" as="h1" color="cotton" className={sprinkles({mB: 48})}>
        Hi&nbsp;{`${data?.me?.userProfile?.firstName},`}
        <br />
        let&apos;s register your test
      </Text>
      <Text variant="bodyLarge" className={css.subHeading} as="div" color="cotton">
        This will only take a few minutes. Please do not eat or drink anything 30 minutes before
        taking your sample.
      </Text>
      <Button
        onClick={() => onNext()}
        variant="primary-dark"
        icon="ArrowRight"
        className={sprinkles({mT: 80})}>
        Get Started
      </Button>
    </div>
    <div className={css.imageWrapper}>
      <Image
        src="/image/registration/intro.png"
        alt="kit-registration"
        layout="fill"
        priority
        objectFit="cover"
      />
    </div>
  </div>
);
